import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Address } from '../../interfaces/customer-info/address';
import { AddressTypes } from '../../interfaces/enums/address-types.enum';
import { ADDRESS_TYPES_TRANSLATION } from './constants/address-types.constants';

@Component({
    selector: 'addresses-list',
    templateUrl: './addresses-list.component.html',
    styleUrls: ['../profile-info-base/profile-info-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AddressesListComponent {

    @Input()
    public set addresses(addresses: Address[]) {
        this.addressesList = addresses.map(address => ({
            type: this.getAddressType(address.type),
            value: this.formatAddress(address)
        }));
    }

    public addressesList: { type: string, value: string }[] = [];

    private formatAddress(address: Address): string {
        const { line1, line2, city, state, zipCode } = address;
        const addressLines = line1 + (line2 == null || line2 === '' ? '' : ' ' + line2);
        const addressCity = city ?? '---';
        const addressState = state == null || state === '' || state === '0' ? '---' : state;
        return `${addressLines}, ${addressCity}, ${addressState}, ${zipCode}`;
    }

    private getAddressType(addressType: AddressTypes): string {
        return ADDRESS_TYPES_TRANSLATION.has(addressType) ? ADDRESS_TYPES_TRANSLATION.get(addressType) : '';
    }
}